import { Link } from 'react-router-dom';

export const Privacidad = () => (
  <div className="min-h-screen bg-[#0A0A0A] text-white">
    <div className="max-w-3xl mx-auto px-6 py-24">
      <Link to="/" className="font-mono text-[11px] tracking-widest uppercase text-gold hover:text-white transition-colors mb-12 inline-block">
        ← Volver
      </Link>
      <h1 className="font-display text-4xl font-light mb-12">Política de Privacidad</h1>

      <div className="space-y-10 font-sans text-sm text-white/70 leading-relaxed">

        <section>
          <h2 className="text-white font-medium mb-3">1. Responsable del tratamiento</h2>
          <ul className="space-y-1 list-none">
            <li><strong className="text-white/90">Identidad:</strong> L&C Digital & Consulting, S.L.</li>
            <li><strong className="text-white/90">NIF:</strong> B22652069</li>
            <li><strong className="text-white/90">Domicilio:</strong> Calle del Poeta Joan Maragall 23, 28020 Madrid</li>
            <li><strong className="text-white/90">Contacto DPO:</strong> legal@lycconsulting.com</li>
          </ul>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">2. Datos que recabamos</h2>
          <p>A través del formulario de contacto del Sitio recabamos: nombre, dirección de correo electrónico, nombre de la empresa y el mensaje que nos envías voluntariamente.</p>
          <p className="mt-2">No recabamos categorías especiales de datos (datos sensibles) a través del Sitio.</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">3. Finalidad y base legal</h2>
          <ul className="mt-2 space-y-3">
            <li>
              <strong className="text-white/90">Atender tu solicitud de contacto</strong> — Base legal: ejecución de un precontrato o consentimiento del interesado (art. 6.1.b y 6.1.a RGPD).
            </li>
            <li>
              <strong className="text-white/90">Comunicaciones comerciales sobre nuestros servicios</strong> — Solo si nos das tu consentimiento expreso. Base legal: art. 6.1.a RGPD. Puedes retirar tu consentimiento en cualquier momento.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">4. Conservación de datos</h2>
          <p>Conservamos tus datos mientras sea necesario para atender tu solicitud y, en su caso, durante el tiempo legalmente exigido. Si no existe relación contractual posterior, los datos se eliminan a los 12 meses desde el último contacto.</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">5. Destinatarios</h2>
          <p>No cedemos tus datos a terceros salvo obligación legal. Utilizamos Netlify, Inc. (EE.UU.) como procesador para la recepción de formularios de contacto, bajo las garantías del Marco de Privacidad UE-EE.UU.</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">6. Tus derechos</h2>
          <p>Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a <strong className="text-white/90">legal@lycconsulting.com</strong> con copia de tu documento de identidad.</p>
          <p className="mt-2">Si consideras que el tratamiento no es conforme a la normativa, puedes presentar una reclamación ante la <strong className="text-white/90">Agencia Española de Protección de Datos</strong> (aepd.es).</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">7. Seguridad</h2>
          <p>Aplicamos medidas técnicas y organizativas adecuadas para proteger tus datos frente a accesos no autorizados, pérdida o destrucción accidental, conforme al artículo 32 del RGPD.</p>
        </section>

        <p className="text-white/40 text-xs pt-4">Última actualización: mayo 2026</p>
      </div>
    </div>
  </div>
);
